import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../../Services/Api/ApiServices";

export const GetAllAcademicDegree = createAsyncThunk(
  "DropDowns/GetAllSU_ST_MRI_AcademicDegree",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllSU_ST_MRI_AcademicDegree"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const GetAllSU_ST_RPI_AcademicDegree = createAsyncThunk(
  "DropDowns/GetAllAcademicDegree",
  async (_, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/DropDowns/GetAllAcademicDegree"
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "dataaaa");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
const DropDownAcademicDegree = createSlice({
  name: "DropDownAcademicDegree",
  initialState: {
    DropDownAcademicDegree: [],
    loadingDropDownAcademicDegree: false,
    errorDropDownAcademicDegree: null,
    //-----------------------------------------------------
    DropDownSU_ST_RPI_AcademicDegree: [],
    loadingDropDownSU_ST_RPI_AcademicDegree: false,
    errorDropDownSU_ST_RPI_AcademicDegree: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllAcademicDegree.pending, (state, action) => {
        state.loadingDropDownAcademicDegree = true;
        state.DropDownAcademicDegree = action.payload;
        state.errorDropDownAcademicDegree = null;
      })
      .addCase(GetAllAcademicDegree.fulfilled, (state, action) => {
        state.loadingDropDownAcademicDegree = false;
        state.DropDownAcademicDegree = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllAcademicDegree.rejected, (state, action) => {
        state.loadingDropDownAcademicDegree = false;
        state.errorDropDownAcademicDegree = action.payload;
      });
    //--------------------------------------------------------------
    builder
      .addCase(GetAllSU_ST_RPI_AcademicDegree.pending, (state, action) => {
        state.loadingDropDownSU_ST_RPI_AcademicDegree = true;
        state.DropDownSU_ST_RPI_AcademicDegree = action.payload;
        state.errorDropDownSU_ST_RPI_AcademicDegree = null;
      })
      .addCase(GetAllSU_ST_RPI_AcademicDegree.fulfilled, (state, action) => {
        state.loadingDropDownSU_ST_RPI_AcademicDegree = false;
        state.DropDownSU_ST_RPI_AcademicDegree = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetAllSU_ST_RPI_AcademicDegree.rejected, (state, action) => {
        state.loadingDropDownSU_ST_RPI_AcademicDegree = false;
        state.errorDropDownSU_ST_RPI_AcademicDegree = action.payload;
      });
  },
});

export default DropDownAcademicDegree.reducer;
